'use client'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { useTranslation } from 'react-i18next'
import AdvertiseForm from './AdvertiseForm'

const AdvertisePageComponents = () => {
  const { t } = useTranslation()
  const [activeMenuItem, setActiveMenuItem] = useState<string>('ad_home_page')
  const pathName = usePathname()

  useEffect(() => {
    setActiveMenuItem(pathName.split('/').pop() || '')
  }, [pathName])

  const handleMenuItemClick = (menuItem: string) => {
    setActiveMenuItem(menuItem)
  }

  const websiteMenuItems = [
    'ad_home_page',
    'ad_news_details_page',
    'ad_search_page',
    'ad_sales_offer_buyers_alert',
    'ad_news_listing',
    'ad_sales_offer_buyers_alert_details',
    'ad_contact_us',
  ]

  return (
    <div>
      <div className="flex flex-col items-center mobile-width mobile:text-center mobile:mt-[10px]">
        <h1 className="text-center text-[28px] font-ns_bold mt-[50px] mobile:mt-[20px] mobile:text-[18px]">
          {t('Advertising')}
        </h1>
        <p className="text-[16px] text-[#222222] mobile:text-[14px] mobile:px-[20px]">
          {t(
            'We’ve got three types of advertising services. Opt for the one which best for your business.'
          )}
        </p>
        <div className="flex bg-[#f8ffea] py-[32px] px-[85px] gap-[51px] mt-[30px] mobile-width mobile:flex-col mobile:px-[20px] mobile:mt-[15px] mobile:gap-[10px]">
          <p className="text-[20px] font-ns_bold text-[#222222] mobile:text-[16px]">
            {t('Include your advertisement on the fructidor.com')}
          </p>
          <AdvertiseForm />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center bg-[#fafafa] h-[70px] mt-[53px] mobile-width mobile:mt-[0] mobile:h-[50px] ">
        <ul className="flex gap-[52px] h-[70px] items-center justify-center mobile:gap-[20px]">
          <li
            className={`flex h-[70px] items-center justify-center font-bold mobile:h-[50px] ${websiteMenuItems.includes(activeMenuItem) ? 'text-[#df7d2f] border-b border-solid border-[#df7d2f] font-bold' : ''}`}
          >
            <Link
              href="/advertise_page/website_ad"
              locale={false}
              onClick={() => handleMenuItemClick('ad_home_page')}
            >
              {t('Website')}
            </Link>
          </li>
          <li
            className={`flex h-[70px] items-center justify-center font-bold mobile:h-[50px] ${activeMenuItem === 'news_letter_ad' ? 'text-[#df7d2f] border-b border-solid border-[#df7d2f] font-bold' : ''}`}
          >
            <Link
              href="/advertise_page/news_letter_ad"
              locale={false}
              onClick={() => handleMenuItemClick('news_letter_ad')}
            >
              {t('Newsletter')}
            </Link>
          </li>
          <li
            className={`flex h-[70px] items-center justify-center font-bold mobile:h-[50px] ${activeMenuItem === 'print_directory' ? 'text-[#df7d2f] border-b border-solid border-[#df7d2f] font-bold' : ''}`}
          >
            <Link
              href="/advertise_page/print_directory"
              locale={false}
              onClick={() => handleMenuItemClick('print_directory')}
            >
              {t('Print Directory')}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default AdvertisePageComponents
